import { Suspense, lazy } from 'react';

import { ProductMenuApp } from '~/features/app/types';

// `@workday/platform-kernel-wired-ui` is ~90 kB gzipped and only ever renders
// for Workday-provisioned users (those with `apps`). Lazy-load it so it stays
// out of the entry chunk and downloads on demand.
const WorkdayProductMenu = lazy(() =>
  import('@workday/platform-kernel-wired-ui').then((module) => ({
    default: module.ProductMenu,
  })),
);

interface Props {
  apps?: ProductMenuApp[];
}

export const ProductMenu = ({ apps }: Props) => {
  if (!apps?.length) {
    return null;
  }
  return (
    <Suspense fallback={null}>
      <WorkdayProductMenu items={apps} />
    </Suspense>
  );
};
